var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenColorOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11344 12.1782L4 9.06473L11.6103 1.4541L14.7237 4.56754L7.11344 12.1782ZM5.77855 9.06473L7.11344 10.3996L12.9455 4.56754L11.6106 3.23266L5.77855 9.06473Z",
    fill: "#983B01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6229 4.66868L13.7338 3.77922C14.1018 3.41114 14.1018 2.81243 13.7338 2.44434C13.3657 2.07625 12.767 2.07661 12.3989 2.44434L11.5098 1.55489C12.3683 0.696372 13.7647 0.696724 14.6232 1.55489C15.4814 2.4134 15.4814 3.81016 14.6229 4.66868Z",
    fill: "#983B01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27894 12.7679C4.05078 12.7679 3.82929 12.6779 3.66476 12.5134C3.46191 12.3105 3.37226 12.0208 3.425 11.7389L3.78886 9.79578C3.79343 9.77152 3.79589 9.75324 3.7966 9.74094C3.81593 9.41609 3.95304 9.11129 4.18261 8.88172L4.8889 8.17578L8.00234 11.2892L7.29605 11.9955C7.07773 12.2138 6.78875 12.3495 6.48148 12.378C6.41293 12.3843 6.33875 12.3973 6.28179 12.4079L4.43925 12.7528C4.38582 12.763 4.33203 12.7679 4.27894 12.7679ZM5.01511 10.0805L4.76585 11.4126L6.05046 11.1721C6.06558 11.1693 6.0814 11.1665 6.09793 11.1634L5.01511 10.0805Z",
    fill: "#983B01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 15.0882H3.20055C1.83859 15.0882 0.730469 13.9801 0.730469 12.6182V5.19176C0.730469 3.8298 1.83859 2.72168 3.20055 2.72168H7.74238V3.7507H3.20055C2.40602 3.7507 1.75949 4.39723 1.75949 5.19176V12.6182C1.75949 13.4127 2.40602 14.0592 3.20055 14.0592H10.627C11.4215 14.0592 12.068 13.4127 12.068 12.6182V8.38184H13.097V12.6182C13.097 13.9801 11.9889 15.0882 10.627 15.0882Z",
    fill: "#983B01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenColorOutlinedIcon);
export default __webpack_public_path__ + "static/media/editPenColorOutlinedIcon.fc6351f4aac05b4ecfda81f14cab7802.svg";
export { ForwardRef as ReactComponent };